<template>
    <li :class="{active:isActive, open:content.open, 'is-content':!content.child && content.type !== 'stories'}">
        <div class="content">
            <div class="more" :class="{'child':content.child}" @click="open">
                <i class="fal fa-fw" :class="content.open?'fa-angle-down':'fa-angle-right'"></i>
            </div>
            <div class="label" @click="show">
                <i class="fal" :class="$store.getters.iconByType(content.type)"/>
                <span class="text">{{ content.label }}</span>
                <span class="data" v-if="content.child && content.child.length > 0 && content.object.getObjectType() !== 'story'">{{content.child.length}}</span>
                <div class="close" v-if="!content.child && content.type !== 'stories' || content.type === 'story'" @click.stop.prevent="nav.close(content)">
                    <i class="fal fa-times"></i>
                </div>
            </div>
        </div>
    
        <ul class="tree sub" v-if="content.open && content.child">
            <tree-li-vertical v-for="(child,key) in content.child" :key="key" :content="child"/>
        </ul>
        
    </li>
</template>

<script>
import Btn from "@/modules/buttons/btn";
import nav from "@/class/nav/nav";
export default {
    name: "tree-li-vertical",
    components: {Btn},
    props:{
        content:Object,
    },
    data(){
      return{
          nav:nav,
      }
    },
    methods:{
        open(){
            this.content.open = !this.content.open
        },
        show(){
            this.nav.show(this.content)
        },
    },
    computed:{
        isActive(){
            return this.nav.isActive(this.content.object.getRoute())
        }
    }
}
</script>